export const urls = {
    apiBaseUrl: 'https://jobportal.srashtasoft.in'
}